import { createSlice } from "@reduxjs/toolkit";
import { DRUCKPFAHL } from "../../constants.js";
import { reset } from "../resetParameters.js";

// DE: Belastungsart/-richtung
// EN: Load Type

const initialState = {
  name: DRUCKPFAHL,
};

const belastungsartUndRichtungSlice = createSlice({
  name: "belastungsartUndRichtung",
  initialState,
  reducers: {
    setBelastungsartUndRichtungState(state, action) {
      state.name = action.payload.name;
    },
    setBelastungsartUndRichtung(state, action) {
      state.name = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return initialState;
    });
  },
});

export const { setBelastungsartUndRichtungState, setBelastungsartUndRichtung } =
  belastungsartUndRichtungSlice.actions;

export default belastungsartUndRichtungSlice.reducer;

export const selectBelastungsartUndRichtung = (state) => state.belastungsartUndRichtung.name;
